import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCircleInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"circle-info, info circle, tooltip, information"} maskId="square-filled-radius-0-stroke-1-IconCircleInfo"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM10 10H12.5L12.5 16L11.5 16L11.5 11H10V10ZM11.5 9V8H12.5V9H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCircleInfo;
